import { Button } from 'react-bootstrap';

import XIcon from '~/components/icons/XIcon';

interface ActiveFilterProps {
  label: string;
  value: string | number | string[];
  onClick: () => void;
}

const ActiveFilter = ({ label, value, onClick }: ActiveFilterProps) => {
  return (
    <Button variant="light-gray" onClick={onClick} className="active-filter">
      <span className="active-filter__label">{label}:</span> <span className="active-filter__value">{value}</span>{' '}
      <XIcon />
    </Button>
  );
};

export default ActiveFilter;
